<template>
  <div class="account-setting-security">
    <a-list itemLayout="horizontal" :dataSource="data">
      <a-list-item slot="renderItem" slot-scope="item">
        <a slot="actions">{{ item.action }}</a>
        <a-list-item-meta :description="item.description">
          <div slot="title">{{ item.title }}</div>
        </a-list-item-meta>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [
        {
          title: '账号密码',
          description: '已设置，可以通过账号密码登录',
          action: '修改',
        },
        {
          title: '保密问题',
          description: '未设置密保问题，密保问题可有效保护账户安全',
          action: '设置',
        },
        {
          title: '设备绑定',
          description: '未绑定设备，绑定设备可有效保护账户安全',
          action: '绑定',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.account-setting-security {
  height: 100%;
  padding: @padding-lg;
  background: white;
  border-radius: @border-radius-base;
  box-shadow: @box-shadow-base;
}
</style>
